import React from 'react';
import Sidebar from '../components/Sidebar';
import AdminInstructionsCard from '../components/AdminInstructionsCard';
import { Container } from 'react-bootstrap';
import AdminModelSelector from '../components/AdminModelSelector';

function InstructAIPage() {
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="d-flex">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Container
        fluid
        className="pt-4"
        style={{ marginLeft: collapsed ? '60px' : '220px', transition: 'margin-left 0.3s ease' }}
      >
        <AdminModelSelector />
        <AdminInstructionsCard />
      </Container>
    </div>
  );
}

export default InstructAIPage;
